export default {
  approvals: {
    validateRequest: 'Validate request'
  }
}



// WEBPACK FOOTER //
// ./src/modules/approvals/lang/en.js